import {
  Container,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core";
import React from "react";
import useFetch from "../../../../hooks/useFetch";
import "./Req.css";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 145,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const InProgress = () => {
  const classes = useStyles();
  const [view, setView] = React.useState("");

  const handleChange = (event) => {
    setView(event.target.value);
  };
  const { data } = useFetch("https://abc-backend.onrender.com/api/quotes");

  return (
    <div className="adminTReq">
      <div className="approvalPage">
        <div className="approvalHeading">
          <Container>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={1} md={12}>
                <h5 className="approvalTitle">RFQ No</h5>
                <input type="text" className="approvalInput" />
              </Grid>
              <Grid item xs={12} lg={1} md={12}>
                <h5 className="approvalTitle">Product Type</h5>
                <input type="text" className="approvalInput" />
              </Grid>
              <Grid item xs={12} lg={2} md={12}>
                {" "}
                <h5 className="approvalTitle lg4">Customer Name</h5>
                <input type="text" className="approvalInput lg4" />
              </Grid>
              <Grid item xs={12} lg={1} md={12}>
                {" "}
                <h5 className="approvalTitle">Weight</h5>
                <input type="text" className="approvalInput" />
              </Grid>
              <Grid item xs={12} lg={1} md={12}>
                <h5 className="approvalTitle">Size</h5>
                <input type="text" className="approvalInput" />
              </Grid>
              <Grid item xs={12} lg={2} md={12}>
                <h5 className="approvalTitle lg4">Ready to load</h5>
                <input
                  type="date"
                  data-date-inline-picker="true"
                  className="approvalInput lg4"
                />
              </Grid>
              <Grid item xs={12} lg={1} md={12}>
                <h5 className="approvalTitle">From</h5>
                <input type="text" className="approvalInput" />
              </Grid>
              <Grid item xs={12} lg={1} md={12}>
                <h5 className="approvalTitle">To</h5>
                <input type="text" className="approvalInput" />
              </Grid>
              <Grid item xs={12} lg={1} md={12}>
                <h5 className="approvalTitle">Type</h5>
                <input type="text" className="approvalInput" />
              </Grid>
              <Grid item xs={12} lg={2} md={12}>
                <h5 className="approvalTitle lg4">Actions</h5>
              </Grid>
            </Grid>
          </Container>
        </div>
        {data?.map((item) => (
          <>
            {item.InProgress && (
              <div className="approvalTabel">
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">100001</h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {item?.data?.quoteIntValue?.productType}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={2} md={12}>
                    <h5 className="approvalTabelTitle lg3">
                      {
                        item?.data?.loadingUnDetailsValue[0]
                          ?.contactPersonNameFrom
                      }
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {item?.data?.productDetailsValue[0]?.weight}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {" "}
                      {item?.data?.productDetailsValue[0]?.sizeInput}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={2} md={12}>
                    <h5 className="approvalTabelTitle lg3">
                      {" "}
                      {item?.data?.quoteIntValue?.loadDate}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {item?.data?.loadingUnDetailsValue[0]?.locationFrom}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {item?.data?.loadingUnDetailsValue[0]?.locationTo}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {" "}
                      {item?.data?.quoteIntValue?.transportationType}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={2} md={12}>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel id="demo-simple-select-autowidth-label">
                        Submit Quote
                      </InputLabel>
                      <Select
                        value={view}
                        onChange={handleChange}
                        displayEmpty
                        defaultValue={"Approve"}
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem value={"Submit Quote"}>View</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default InProgress;
